import React, { useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Typography from '@material-ui/core/Typography';
import { useHistory } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';

import { useStyles, listStyles, customCardStyles } from './Details.styled';
import { buildUrl } from 'utils';
import { Card } from 'components/UI';
import { locationActions } from 'state/modules/locations';

import i18n from 'i18n-js';

import { Link, List, Divider, ListItem, ListItemText } from '@material-ui/core';

const LocationDetails = ({ id }) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const itemsClasses = listStyles();
  const cardClasses = customCardStyles();
  const { location } = useSelector((state) => state.locations);

  useEffect(() => {
    if (id) {
      dispatch(locationActions.fetchLocationsById(id));
    }
  }, []) // eslint-disable-line

  const goToVehicleEdition = (e) => {
    e.preventDefault();
    history.push(buildUrl(`/locations/${id}/update`));
  };

  const getLocationData = (location = {}) => {
    const locationInfo = [
      { label: i18n.t('locations.zone_name'), value: location.name || '-' },
      { label: i18n.t('locations.address'), value: location?.address || '-' },
      { label: i18n.t('locations.country'), value: location.country || '-' },
      { label: i18n.t('locations.state'), value: location?.state || '-' },
      { label: i18n.t('locations.city'), value: location?.city || '-' },
      { label: i18n.t('locations.zip_code'), value: location?.zipcode || '-' },
      { label: i18n.t('locations.time_zone'), value: location?.time_zone || '-' },
    ];

    return locationInfo;
  };

  return (
    <Card
      title={i18n.t('locations.location_info')}
      headerActionType="vertical"
      contentRootClasses={cardClasses}
    >
      <>
        <div className={classes.cardContentPadding}>
          <Grid container direction="row" alignItems="center" spacing={1}>
            <Grid item xs={8}>
              <Typography variant="h3">
                <Box className={classes.name}>ID# {id}</Box>
              </Typography>
            </Grid>
            <Grid item xs={4} className={`${classes.textRight}`}>
              <Typography>
                <Link
                  href="#"
                  data-cy="update-info"
                  onClick={goToVehicleEdition}
                  className={classes.vehicleLink}
                >
                  {i18n.t('locations.update_info')}
                </Link>
              </Typography>
            </Grid>
          </Grid>
          <Divider className={classes.divider} />

          <List className={classes.vehicleList}>
            {getLocationData(location).map((val, index) => (
              <Fragment key={index}>
                {(val?.condition || val?.condition === undefined) && (
                  <ListItem className={classes.vehicleListItem}>
                    <ListItemText
                      classes={itemsClasses}
                      primary={val.label}
                      secondary={val.value}
                    />
                  </ListItem>
                )}
              </Fragment>
            ))}
          </List>
        </div>
      </>
    </Card>
  );
};

export default LocationDetails;
